import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"min-height":"100vh"} }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12\" style=\"padding-top:10px;padding-bottom:10px;\"><div class=\"elfsight-app-c349f1d8-7c7e-4b27-93c1-be19944e141b\"></div></div><div class=\"col-lg-12 col-md-12 col-xs-12\"><div class=\"textcard disclaimer\"><input id=\"countryselect\" style=\"display:none;\" type=\"number\" value=\"2\"></div></div>", 2)
const _hoisted_6 = {
  class: "row",
  id: "premiumsection"
}
const _hoisted_7 = { class: "col-lg-12 col-md-12 col-12" }
const _hoisted_8 = { class: "itemcard" }
const _hoisted_9 = { id: "buy" }
const _hoisted_10 = { id: "slide1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "Already have ProxyScrape premium?", -1)
const _hoisted_12 = { class: "loginbtn" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  id: "showhow",
  class: "btn btn-blue"
}, "login", -1)

import ShopContainer from '@/components/services/premium/ShopContainer.vue';
import CountryContainer from '@/components/services/premium/CountryContainer.vue';
import PaymentMethods from '@/components/shared/PaymentMethods.vue';
import PremiumFAQ from '@/components/services/premium/PremiumFAQ.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ShopContainer),
      _createVNode(CountryContainer),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(PaymentMethods),
        _hoisted_4,
        _createVNode(PremiumFAQ)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("a", _hoisted_12, [
                  _createVNode(_component_router_link, { to: "/login" }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})